import { messages } from 'AuthPart/authpart.messages';

export const DefaultError = messages['setPasswordForm.error.default'];

export const loginErrors = new Map([
    [messages['server.token.error'], messages['server.token.invalid.error']],
]);
